import { downloadBlob, toFileSystemCompatibleString } from "@buzzeasy/shared-frontend-utilities";
import { sessionRecord } from "@buzzeasy/shared-frontend-utilities/sessionRecording";
import { MessageInstance } from "antd/es/message/interface";
import { TFunction } from "i18next";

export async function copyTextToClipboard(text: string, messageApi: MessageInstance, t: TFunction<"translation">): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    messageApi.success(t("util.successfulCopy"), 1);
  }
  catch {
    messageApi.error(t("util.failedToCopy"), 1);
  }
}

export function downloadSessionRecordingLog() {
  const events = sessionRecord.getRecordedEvents();
  const eventsString = JSON.stringify(events);
  const datetime = toFileSystemCompatibleString(new Date());

  downloadBlob([eventsString], "application/json", `AgentApp eventlog ${datetime}.json`);
}

export function serializeError(error: unknown, seen = new WeakSet<object>()): unknown {
  if (!(error instanceof Error))
    return error;

  if (seen.has(error))
    return "[Circular]";
  seen.add(error);

  const result: Record<string, unknown> = { name: error.name };

  for (const key of Object.getOwnPropertyNames(error)) // message, stack, cause, custom props
    result[key] = serializeError((error as unknown as Record<string, unknown>)[key], seen);

  if (error instanceof AggregateError)
    result.errors = error.errors.map(e => serializeError(e, seen));

  return result;
}
